import moment from 'moment';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import daterangePickerPtBr from '../entrypoints/src/admin/i18n/daterange-picker.pt-br';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['statsCheckbox', 'statsQuantity', 'statsTotal', 'statsHeaderCheckbox' ]

  connect() {
    moment.locale('pt-BR');

    this.$fmFilterBookEntry = this.element.querySelector('form.filter-book-entries');
		this.dateRangePicker();

    $('select.chart-of-accounts').select2();
    $('select.cost-centers').select2();

		return this;
  }

	dateRangePicker() {
    if ($('.book-entry-daterangepicker').length == 0) {
        return;
    }

    let _this = this;

    $('.book-entry-daterangepicker').each((_, el) => {
      let picker = $(el),
        startDate = moment(picker.data('startDate')),
        endDate = moment(picker.data('endDate'));

      picker.daterangepicker({
          locale: daterangePickerPtBr,
          startDate: startDate,
          endDate: endDate,
          opens: 'left',
          applyButtonClasses: 'btn btn-sm btn-secondary',
          ranges: {
            'Mês Retrasado': [moment().subtract(2, 'month').startOf('month'), moment().subtract(2, 'month').endOf('month')],
            'Mês Passado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            'Esse Mês': [moment().startOf('month'), moment().endOf('month')],
            'Próximo Mês': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')],
          }
      }, (start, end) => {
        AjaxLoader.show();
        _this.element.querySelector('input[name="financial_system_book_entries_grid[start_date]"]').value = start.format('YYYY-MM-DD');
        _this.element.querySelector('input[name="financial_system_book_entries_grid[end_date]"]').value = end.format('YYYY-MM-DD');
        _this.element.querySelectorAll('input[name="row_selector[]"], input[name="row_selector"]').forEach((it) => it.disabled = true )
        _this.$fmFilterBookEntry.submit();
      });

      this.initDateRangePicker(picker, startDate, endDate, 'Personalizado');
    });
	}

	initDateRangePicker(picker, start, end, label) {
		let title = '', range = '';

		if (label == 'Personalizado') {
			range = start.format('DD MMM YYYY') + ' - ' + end.format('DD MMM YYYY');
		} else {
			title = !!label ? label : 'Esse Mês';
			range = start.format('MMMM [de] YYYY');
		}

		picker.html(range);
	}

  sumSelectedEntries() {
    let totalValue = 0.00
    let quantity   = 0
    this.statsCheckboxTargets.forEach((it) => {
      if (it.checked) {
        quantity   += 1
        totalValue += parseInt(it.dataset.bookEntryValue)
      }
    })
    totalValue = (totalValue / 100).toFixed(2)
    this.statsQuantityTarget.innerHTML = quantity
    this.statsTotalTarget.innerHTML    = `${Traus.company.currency_symbol || 'R$'}${totalValue.toString().replace('.', ',')}`
  }

  selectAllCheckboxes() {
    this.statsCheckboxTargets.forEach(($el) => {
      $el.checked = this.statsHeaderCheckboxTarget.checked;
      this.sumSelectedEntries();
    })
  }
}